export default "<canvas #canvasGrid id=\"canvasGrid\"></canvas>\n"